import {
  MutableRefObject,
  RefObject,
  useEffect,
  useMemo,
  useState,
} from "react";
import {
  ChartingLibraryWidgetOptions,
  IChartingLibraryWidget,
  ResolutionString,
  TradingTerminalWidgetOptions,
} from "tradingView";
import { initDatafeed } from "./datafeed";
import { initDatafeedParams, Transaction } from "./tradeView";
import { BehaviorSubject } from "rxjs";
import { useMount } from "ahooks";
import { GloablMessageSub, GlobalMessageType } from "../rxjs";
import { colors } from "./color";

export const TransSub = new BehaviorSubject<Transaction[]>([]);
const time_frames = [
  { text: "60", resolution: "5", description: "1hour", title: "1hour" },
  { text: "4h", resolution: "5", description: "4hour", title: "4hour" },
  { text: "1d", resolution: "60", description: "1day", title: "1day" },
  { text: "1w", resolution: "60", description: "1week", title: "1week" },
];

export default function useTVChart({
  tvWidgetRef,
}: {
  tvWidgetRef: MutableRefObject<IChartingLibraryWidget | null>;
}) {
  const searchParams: initDatafeedParams = useMemo(() => {
    const url = new URL(window.location.href);
    const obj: any = {};
    [...url.searchParams.entries()].forEach(([key, value]) => {
      obj[key] = value;
    });
    return obj;
  }, []);
  const [params, setParams] = useState<initDatafeedParams>(searchParams);

  useMount(() => {
    const subp = GloablMessageSub.subscribe(({ type, data }) => {
      if (type === GlobalMessageType.KLINE_PARAMS) {
        const { key, value } = data;
        if (key === "loginToken") {
          localStorage.setItem("LOGIN_TOKEN", value);
        }
        if (key && value) {
          setParams((pre) => ({ ...pre, [key]: value }));
        }
      }
    });

    return () => {
      subp.unsubscribe();
    };
  });

  const defaultWidgetProps: Partial<ChartingLibraryWidgetOptions> =
    useMemo(() => {
      const {
        symbol = " ",
        interval = "1" as ResolutionString,
        locale = "zh",
      } = params;
      return {
        symbol,
        interval,
        library_path: "" + "/tradingView/charting_library/",
        locale,
        fullscreen: false,
        autosize: true,
        time_frames,
      } as Partial<ChartingLibraryWidgetOptions>;
    }, [params.symbol, params.interval, params.locale]);

  const address = useMemo(() => params.address, [params]);
  const symbol = useMemo(() => params.symbol || " ", [params]);
  const chain = useMemo(() => params.chain || "Solana", [params]);
  const priceScale = useMemo(() => params.priceScale, [params]);
  const arrow = useMemo(() => params.arrow || "false", [params]);
  const upColor = useMemo(() => params.upColor || colors.green, [params]);
  const downColor = useMemo(() => params.downColor || colors.red, [params]);
  const bgColor = useMemo(() => params.bgColor || colors.dark, [params]);

  const datafeed = useMemo(() => {
    return initDatafeed({
      symbol,
      address,
      priceScale,
      tvWidgetRef,
      arrow,
      chain,
      upColor,
      downColor,
      bgColor,
    });
  }, [address, priceScale, arrow, chain]);

  return {
    ...params,
    symbol,
    widgetProps: {
      datafeed: datafeed as any,
      ...defaultWidgetProps,
    } as TradingTerminalWidgetOptions,
  };
}
